<template>
  <v-container>
    <h2 class="mb-4">Forbidden email domains</h2>
    <v-card>
      <v-card-text>
        <h4>Add new domain:</h4>
        <v-layout row wrap>
          <v-flex xs3>
            <v-text-field
              label="Domain"
              v-model="forbiddenDomainData.domain"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs4 offset-xs1>
            <v-text-field
              label="Description"
              v-model="forbiddenDomainData.description"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs2  offset-xs1>
            <v-btn color="info" @click="saveDomain">Save</v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card>
        <v-card-text>
          <h4>Add new prefix:</h4>
          <v-layout row wrap>
            <v-flex xs3>
              <v-text-field
                label="Prefix"
                v-model="forbiddenDomainData.prefixName"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs4 offset-xs1>
              <v-text-field
                label="Description"
                v-model="forbiddenDomainData.prefixDescription"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs2  offset-xs1>
              <v-btn color="info" @click="savePrefix">Save</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-card>
    <v-card>
      <v-card-text>
        <h4>Add new prefix:</h4>
        <v-layout row wrap>
          <v-flex xs3>
            <v-text-field
              label="Prefix"
              v-model="forbiddenDomainData.prefixName"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs4 offset-xs1>
            <v-text-field
              label="Description"
              v-model="forbiddenDomainData.prefixDescription"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs2  offset-xs1>
            <v-btn color="info" @click="savePrefix">Save</v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-text>
        <h4>Add new prefix:</h4>
        <v-layout row wrap>
          <v-flex xs3>
            <v-text-field
              label="Prefix"
              v-model="forbiddenDomainData.prefixName"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs4 offset-xs1>
            <v-text-field
              label="Description"
              v-model="forbiddenDomainData.prefixDescription"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs2  offset-xs1>
            <v-btn color="info" @click="savePrefix">Save</v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-layout>
      <v-flex xs4>
        <v-text-field
          append-icon="search"
          label="Search by Domain"
          v-model="search.filterByDomain"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <v-data-table
          :headers="headers"
          :items="forbiddenDomains"
          :pagination.sync="pagination"
          :total-items="totalItemsInTable"
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.domain }}</td>
            <td>{{ props.item.prefixName }}</td>
            <td>{{ props.item.description }}</td>
            <td>{{ getDate(props.item.creationDate) }}</td>
            <td>
              <v-flex text-xs-center>
                <v-tooltip bottom>
                  <v-btn
                    color="error"
                    fab flat
                    slot="activator"
                    @click="deleteDomain(props.item.id)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                  <span>Delete</span>
                </v-tooltip>
              </v-flex>
            </td>
          </template>
          <template slot="pageText" slot-scope="{}">
            Page {{pagination.page}} of {{getDomainsTotalPages}}
          </template>
          <v-alert outline color="grey lighten-2" slot="no-results" :value="true" icon="warning">
            No data
          </v-alert>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { clone, path } from 'ramda'
import moment from 'moment' // lib to format date and time

export default {
  name: 'index',
  data () {
    return {
      forbiddenDomainData: {
        domain: '',
        prefixName: '',
        description: '',
        prefixDescription: ''
      },
      search: {
        filterByDomain: ''
      },
      page: 0,
      itemsOnPage: 10,

      pagination: {
        rowsPerPage: 5
      },
      forbiddenDomains: [],
      headers: [
        { text: 'Domain', value: 'domain', sortable: false },
        { text: 'Prefix', value: 'prefixName', sortable: false },
        { text: 'Description', value: 'description', sortable: false },
        { text: 'Date', value: 'date', sortable: false },
        { text: 'Delete', value: 'delete', sortable: false, width: 40 }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getForbiddenEmailDomains',
      'getDomainsTotalPages',
      'getDomainsTotalItems'
    ]),
    totalItemsToNumbers () {
      return parseInt(this.getDomainsTotalItems) || 0
    },
    totalItemsInTable () {
      return this.getDomainsTotalItems || (this.getDomainsTotalPages * this.pagination.rowsPerPage)
    }
  },
  watch: {
    search: {
      handler (newVal) {
        let config = {page: this.page, itemsOnPage: this.itemsOnPage, domain: path(['filterByDomain'], newVal)}
        this.fetchForbiddenDomains(config)
      },
      deep: true
    },
    pagination: {
      handler (newVal, oldVal) {
        if (!this.isPaginationChanged(newVal, oldVal)) return
        const { page, rowsPerPage } = this.pagination
        this.page = page - 1 || 0
        this.itemsOnPage = rowsPerPage || 10
        if (rowsPerPage === -1) this.itemsOnPage = this.getDomainsTotalItems
        let config = {page: this.page, itemsOnPage: this.itemsOnPage,domain: path(['filterByDomain'], this.search)}
        this.fetchForbiddenDomains(config)
      },
      deep: true
    },
    getForbiddenEmailDomains: {
      handler (newVal) {
        if(!newVal) return
        this.forbiddenDomains = clone(this.getForbiddenEmailDomains)
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'fetchForbiddenDomains',
      'saveForbiddenDomain',
      'deleteForbiddenDomain',
      'saveForbiddenEmailPrefix'
    ]),
    isPaginationChanged (newVal, oldVal) {
      return newVal.page !== oldVal.page || newVal.rowsPerPage !== oldVal.rowsPerPage
    },
    async receiveRequiredData () {
      await this.fetchForbiddenDomains()
    },
    getDate (date) {
      return date
        ? moment(date).format('DD-MM-YYYY, , h:mm:ss a')
        : 'Unknown date'
    },
    async saveDomain () {
      await this.saveForbiddenDomain(this.forbiddenDomainData)
      await this.fetchForbiddenDomains()
    },
    async savePrefix () {
      await this.saveForbiddenEmailPrefix(this.forbiddenDomainData)
      await this.fetchForbiddenDomains()
    },
    async deleteDomain (domainId) {
      await this.deleteForbiddenDomain(domainId)
      await this.fetchForbiddenDomains()
    }
  },
  created () {
    this.receiveRequiredData()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/EmailRestriction/index.vue